import { useNavigate } from 'react-router'
import './card-campaign-shortcut.component.scoped.scss'

export interface CardCampaignShortcutsProps {
  icon?: string
  totalCampaigns?: number
  label: any
  path: string
  index: number
}

export default ({ icon = '', totalCampaigns, label, path, index }: CardCampaignShortcutsProps) => {
  const navigate = useNavigate()

  return (
    <div className={`card-campaign-shortcut box-shadow background-position-${index}`}>
      <div className="content-card">
        {icon && (
          <div className="icon-card">{!icon?.startsWith('fa-') ? <img src={icon} alt="icon" /> : <i className={`fa-solid ${icon}`} />}</div>
        )}
        <div className="total-campaigns mt-3">{totalCampaigns && <div className="total-campaigns">{totalCampaigns}</div>}</div>
      </div>
      <div className="label-card" role="button" tabIndex={0} onClick={() => navigate(path)}>
        <span className="label">{label}</span>
        <i className="fa-solid fa-arrow-right" style={{ color: 'var(--primary_color)' }} />
      </div>
    </div>
  )
}
